import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {AuthPanelPage} from "../AuthPanelPage.jsx";
import {Messages} from "../../../../Messages";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {BasePanelPageStyle} from "../BasePanelPage";


class DonationAuthPageStyle extends BasePanelPageStyle {
    @styleRule
    message = this.themeProps.PANEL_MESSAGE_STYLE;
}

@registerStyle(DonationAuthPageStyle)
export class DonationAuthPage extends AuthPanelPage {
    render() {
        return [
            Messages.merchantUsesBlinkForDonations.toString().trim() ?
                <MessageElement message={Messages.merchantUsesBlinkForDonations(iFrameMerchantService.getMerchant().name)}
                                className={this.styleSheet.message}/> : null,
            super.render()
        ];
    }
}
